export const accountingEn = {
  "accounting.jonasChart.title": "Jonas chart review",
  "accounting.jonasChart.subtitle": "Review staged Jonas accounts, their proposed native matches and source evidence. Nothing is changed here.",
  "accounting.jonasChart.emptyTitle": "No staged chart rows",
  "accounting.jonasChart.emptyBody": "No staged Jonas chart account rows are available. Monthly rollups are separate and do not contain native GL account detail.",
  "accounting.jonasChart.statusLabel": "Jonas chart staging status",
  "accounting.jonasChart.totalRows": "{total} staged source rows",
  "accounting.jonasChart.safety": "Read-only review. Proposed matches come from the current chart preview; nothing is applied here.",
  "accounting.jonasChart.incomplete": "Incomplete staging or chart preview: {actual} rows are available; the batch expected {expected}. Review the source transfer and listed issues.",
  "accounting.jonasChart.unknownExpected": "unknown",
  "accounting.jonasChart.batchComplete": "Batch row count matches ({expected})",
  "accounting.jonasChart.sourceAccount": "Jonas account",
  "accounting.jonasChart.proposed": "Proposed native account",
  "accounting.jonasChart.nativeMatch": "Current native match",
  "accounting.jonasChart.flags": "Review flags",
  "accounting.jonasChart.evidenceColumn": "Source evidence",
  "accounting.jonasChart.missingNumber": "Missing account number",
  "accounting.jonasChart.noDescription": "No description",
  "accounting.jonasChart.proposedDetails": "{type}; type from {basis}; {action}",
  "accounting.jonasChart.type.asset": "Asset",
  "accounting.jonasChart.type.liability": "Liability",
  "accounting.jonasChart.type.equity": "Equity",
  "accounting.jonasChart.type.revenue": "Revenue",
  "accounting.jonasChart.type.expense": "Expense",
  "accounting.jonasChart.basis.override": "club override",
  "accounting.jonasChart.basis.jonas_type": "Jonas account type",
  "accounting.jonasChart.basis.number_range": "account number range",
  "accounting.jonasChart.basis.parent": "parent account",
  "accounting.jonasChart.action.create": "create",
  "accounting.jonasChart.action.match": "match",
  "accounting.jonasChart.action.update": "update",
  "accounting.jonasChart.action.unchanged": "unchanged",
  "accounting.jonasChart.noProposal": "No proposal",
  "accounting.jonasChart.active": "Active",
  "accounting.jonasChart.inactive": "Inactive",
  "accounting.jonasChart.noNativeMatch": "No native account match",
  "accounting.jonasChart.noFlags": "None",
  "accounting.jonasChart.issueCount": "{count} issues",
  "accounting.jonasChart.warningCount": "{count} warnings",
  "accounting.jonasChart.evidence": "{file} · record {key}",
  "accounting.jonasChart.batch": "Batch",
  "accounting.jonasChart.batchNumber": "Batch number",
  "accounting.jonasChart.extractId": "Extract ID",
  "accounting.jonasChart.extractedAt": "Captured from Jonas",
  "accounting.jonasChart.notRecorded": "Not recorded",
  "accounting.jonasChart.loadedAt": "Received by ClubCore",
  "accounting.jonasChart.sourceHash": "Source hash",
  "accounting.jonasChart.noProvenance": "Source batch provenance is unavailable.",
  "accounting.jonasChart.noEvidence": "No source evidence fields are available.",
  "accounting.jonasChart.pagination": "Jonas chart review pages",
  "accounting.jonasChart.rowRange": "Rows {from}–{to} of {total}",
  "accounting.jonasChart.previous": "Previous",
  "accounting.jonasChart.next": "Next",


  // The sidebar labels (accounting.nav.*) are in the core catalog: the sidebar shows before this module's chunk loads.
  "accounting.kind.recurring": "Recurring charges",
  "accounting.kind.minimum": "Minimum close",
  "accounting.status.previewed": "Preview",
  "accounting.status.committed": "Posted",
  "accounting.status.partial": "Partly posted",
  "accounting.status.reversed": "Reversed",
  "accounting.status.discarded": "Discarded",
  "accounting.status.finalised": "Finalised",
  "accounting.period.ending": "Period ending {date}",

  "accounting.runs.title": "Billing runs",
  "accounting.runs.subtitle": "Recurring charges such as dues, and the food and beverage minimum close. A run is previewed first; nothing reaches an account until it is posted.",
  "accounting.runs.empty": "No billing runs yet",
  "accounting.runs.emptyBody": "Preview a recurring run to see what would be billed for a month.",
  "accounting.runs.period": "Period",
  "accounting.runs.kind": "Kind",
  "accounting.runs.status": "Status",
  "accounting.runs.postings": "Postings",
  "accounting.runs.amount": "Total",
  "accounting.runs.outcome": "Result",
  "accounting.runs.outcomeCounts": "{posted} posted, {failed} failed",
  "accounting.runs.created": "Created",

  "accounting.newRecurring.button": "New recurring run",
  "accounting.newRecurring.title": "New recurring run",
  "accounting.newRecurring.description": "Works out what each household's charge lines bill for the month. Nothing is posted until you commit the preview.",
  "accounting.newRecurring.month": "Month",
  "accounting.newRecurring.year": "Year",
  "accounting.newRecurring.yearInvalid": "Enter a year between 2000 and 2200.",
  "accounting.newRecurring.postingDate": "Posting date",
  "accounting.newRecurring.postingDateHint": "The date the charges are dated. The first day of the month unless you change it.",
  "accounting.newRecurring.submit": "Preview run",

  "accounting.run.title": "{kind}: {period}",
  "accounting.run.created": "Previewed {date}",
  "accounting.run.period": "Period",
  "accounting.run.postedOn": "Dated {date}",
  "accounting.run.status": "Status",
  "accounting.run.postings": "Postings",
  "accounting.run.postingsHint": "One per account",
  "accounting.run.items": "Items",
  "accounting.run.amount": "Amount",
  "accounting.run.taxService": "Tax and service",
  "accounting.run.total": "Total",
  "accounting.run.counts": "What the run found",
  "accounting.run.showAttention": "Show them",
  "accounting.run.commit": "Commit",
  "accounting.run.discard": "Discard preview",
  "accounting.run.reverse": "Reverse run",
  "accounting.count.not_due": "Not due this month",
  "accounting.count.already_billed": "Already billed",
  "accounting.count.excluded_status": "Left out by status",
  "accounting.count.needs_attention": "Needs attention",
  "accounting.count.before_joining": "Before joining",
  "accounting.count.households": "Accounts checked",
  "accounting.count.met": "Minimum met",
  "accounting.count.shortfalls": "Shortfalls",

  "accounting.banner.previewed": "Nothing has been posted yet",
  "accounting.banner.previewedBody": "This is a preview. Check the items below, then commit to post them to the accounts, or discard it.",
  "accounting.banner.committed": "Posted",
  "accounting.banner.committedBody_one": "{count} entry totalling {amount} was posted to member accounts, dated {date}.",
  "accounting.banner.committedBody_other": "{count} entries totalling {amount} were posted to member accounts, dated {date}.",
  "accounting.banner.partial": "Some accounts could not be posted",
  "accounting.banner.partialBody": "{posted} accounts were posted and {failed} failed. The failed accounts were left untouched; the reasons are listed here.",
  "accounting.banner.failures": "Accounts that failed",
  "accounting.banner.reversed": "This run was reversed",
  "accounting.banner.reversedBody": "Reversed on {date}. Reason: {reason}",
  "accounting.banner.discarded": "This preview was discarded",

  "accounting.items.title": "Items",
  "accounting.items.show": "Show",
  "accounting.items.attention": "Needs attention",
  "accounting.items.account": "Account",
  "accounting.items.household": "Household",
  "accounting.items.description": "Description",
  "accounting.items.amount": "Amount",
  "accounting.items.taxService": "Tax and service",
  "accounting.items.total": "Total",
  "accounting.items.status": "Status",
  "accounting.items.reason": "Reason",
  "accounting.items.requiredSpent": "Required {required}, spent {spent}",
  "accounting.items.none": "No items",
  "accounting.items.noneBody": "This run has nothing to bill.",
  "accounting.items.noMatch": "No matching items",
  "accounting.items.noMatchBody": "Clear the filter to see more.",
  "accounting.itemStatus.planned": "To post",
  "accounting.itemStatus.posted": "Posted",
  "accounting.itemStatus.skipped": "Needs attention",
  "accounting.itemStatus.failed": "Failed",
  "accounting.itemStatus.reversed": "Reversed",

  "accounting.commit.title": "Post this run?",
  "accounting.commit.body_one": "This posts {count} entry totalling {total} for {period} to member accounts.",
  "accounting.commit.body_other": "This posts {count} entries totalling {total} for {period} to member accounts.",
  "accounting.commit.note": "If the accounts changed since the preview, nothing is posted and you can preview again.",
  "accounting.commit.confirm": "Post to accounts",
  "accounting.stale.body": "Nothing was posted. Preview again to see what would be posted now.",
  "accounting.stale.previewAgain": "Preview again",
  "accounting.discard.title": "Discard this preview?",
  "accounting.discard.body": "The preview is removed. Nothing was posted, so no account changes.",
  "accounting.discard.confirm": "Discard preview",
  "accounting.reverse.title": "Reverse this run",
  "accounting.reverse.description_one": "This reverses every posting of the run: {count} account will get an offsetting entry, and the period can be billed again.",
  "accounting.reverse.description_other": "This reverses every posting of the run: {count} accounts will get an offsetting entry, and the period can be billed again.",
  "accounting.reverse.reason": "Reason",
  "accounting.reverse.reasonHint": "Kept with the run and in the audit log. At least 3 characters.",
  "accounting.reverse.reasonRequired": "Give a reason of at least 3 characters.",
  "accounting.reverse.submit": "Reverse run",

  "accounting.minimum.title": "Minimum close",
  "accounting.minimum.subtitle": "Bills members who spent less than their food and beverage minimum in a finished period.",
  "accounting.minimum.periods": "Periods ready to close",
  "accounting.minimum.periodEnd": "Period ended",
  "accounting.minimum.plans": "Plans",
  "accounting.minimum.actions": "Actions",
  "accounting.minimum.preview": "Preview shortfalls",
  "accounting.minimum.none": "No finished periods",
  "accounting.minimum.noneBody": "A period appears here once a minimum plan with terms has a period that has ended.",
  "accounting.minimum.previous": "Earlier minimum runs",

  "accounting.statements.title": "Statement close",
  "accounting.statements.subtitle": "Closes a month: posts interest, locks the period against back-dated postings and stores each household's statement.",
  "accounting.statements.closedThrough": "Closed through",
  "accounting.statements.nothingClosed": "Nothing closed yet",
  "accounting.statements.lockedHint": "Postings dated up to here are refused.",
  "accounting.statements.noneClosedHint": "The first close can be any month that has ended.",
  "accounting.statements.nextPeriod": "Next period to close",
  "accounting.statements.range": "{start} to {end}",
  "accounting.statements.nextHint": "Months are closed in order.",
  "accounting.statements.anyMonth": "Any finished month",
  "accounting.statements.anyMonthHint": "Later months are then closed in order.",
  "accounting.statements.previewTitle": "Preview statement close",
  "accounting.statements.previewBody": "A preview shows every statement with its interest and posts nothing.",
  "accounting.statements.periodEnd": "Period end",
  "accounting.statements.periodEndHint": "The last day of the month to close.",
  "accounting.statements.statementDate": "Statement date",
  "accounting.statements.statementDateHint": "The date printed on the statements. The period end unless you change it.",
  "accounting.statements.includeInterest": "Include interest and late fees",
  "accounting.statements.includeInterestHint": "By the club's rule, when it has one switched on.",
  "accounting.statements.preview": "Preview statement close",
  "accounting.statements.past": "Statement runs",
  "accounting.statements.pastNone": "No statement runs yet",
  "accounting.statements.pastNoneBody": "Previews and finalised closes appear here.",
  "accounting.statements.period": "Period",
  "accounting.statements.count": "Statements",
  "accounting.statements.interest": "Interest",
  "accounting.statements.closing": "Closing",
  "accounting.statements.finalised": "Finalised",
  "accounting.statements.opening": "Opening",
  "accounting.statements.charges": "Charges",
  "accounting.statements.payments": "Payments",
  "accounting.statements.other": "Credits and other",
  "accounting.statements.overdue": "Overdue",
  "accounting.statements.delivery": "Delivery",
  "accounting.statements.number": "Number",
  "accounting.statements.skipped_one": "{count} account with a balance gets no statement",
  "accounting.statements.skipped_other": "{count} accounts with a balance get no statement",
  "accounting.statements.skippedBody": "Their status does not receive statements (set on Members > Settings > Statuses). Together they owe {total}. Change the status or its statement flag if they should be mailed.",
  "accounting.statements.skippedList": "Accounts that get no statement",
  "accounting.statements.skippedMore": "{count} more are not listed here.",
  "accounting.statements.status": "Status",
  "accounting.statements.balance": "Balance",
  "accounting.statements.interestAccounts_one": "{count} account charged",
  "accounting.statements.interestAccounts_other": "{count} accounts charged",
  "accounting.statements.byDelivery": "Statements by delivery",
  "accounting.statements.runTitle": "Statements: {range}",
  "accounting.statements.dated": "dated {date}",
  "accounting.statements.discard": "Discard preview",
  "accounting.statements.finalise": "Finalise",
  "accounting.statements.bannerPreview": "Nothing has been posted yet",
  "accounting.statements.bannerPreviewBody": "This is a preview. Interest is posted, the period is locked and the statements are stored only when you finalise.",
  "accounting.statements.bannerFinal": "This close is final",
  "accounting.statements.bannerFinalBody_one": "Finalised {date}. {count} interest entry was posted and the period is locked.",
  "accounting.statements.bannerFinalBody_other": "Finalised {date}. {count} interest entries were posted and the period is locked.",
  "accounting.statements.bannerDiscarded": "This preview was discarded",
  "accounting.statements.itemsTitle": "Statements in this preview",
  "accounting.statements.search": "Search accounts",
  "accounting.statements.deliveryFilter": "Delivery",
  "accounting.statements.interestFilter": "Interest",
  "accounting.statements.withInterest": "With interest",
  "accounting.statements.withoutInterest": "Without interest",
  "accounting.statements.noItems": "No statements to produce",
  "accounting.statements.noItemsBody": "No account has a balance or activity in this period.",
  "accounting.statements.noMatch": "No matching statements",
  "accounting.statements.stored": "Stored statements",
  "accounting.statements.deliveryTabs": "Delivery method",
  "accounting.statements.noStored": "No statements here",
  "accounting.statements.noStoredBody": "No stored statement matches this delivery method.",
  "accounting.statements.downloadPrint": "Download all to print",
  "accounting.statements.view": "View",
  "accounting.statements.viewFor": "View statement for account {account}",
  "accounting.statements.pdf": "Download PDF",
  "accounting.statements.pdfFor": "Download PDF for account {account}",
  "accounting.delivery.email": "Email",
  "accounting.delivery.print": "Print",
  "accounting.delivery.both": "Email and print",
  "accounting.delivery.none": "None",
  "accounting.tab.all": "All",
  "accounting.tab.email_one": "Email ({count})",
  "accounting.tab.email_other": "Email ({count})",
  "accounting.tab.print_one": "Print ({count})",
  "accounting.tab.print_other": "Print ({count})",
  "accounting.tab.none_one": "No delivery ({count})",
  "accounting.tab.none_other": "No delivery ({count})",

  "accounting.finalise.title": "Finalise this statement close?",
  "accounting.finalise.body_one": "This closes {range} and stores {count} statement.",
  "accounting.finalise.body_other": "This closes {range} and stores {count} statements.",
  "accounting.finalise.interest_one": "It posts {amount} of interest to {count} account.",
  "accounting.finalise.interest_other": "It posts {amount} of interest to {count} accounts.",
  "accounting.finalise.lock": "It locks the period: nothing can be posted with a date up to {date} afterwards.",
  "accounting.finalise.store": "It stores each household's statement exactly as it is now.",
  "accounting.finalise.irreversible": "This cannot be undone.",
  "accounting.finalise.confirm": "Finalise close",
  "accounting.statementDiscard.title": "Discard this preview?",
  "accounting.statementDiscard.body": "The preview is removed. Nothing was posted and the period stays open.",
  "accounting.statementDiscard.confirm": "Discard preview",

  "accounting.txKind.charge": "Charges",
  "accounting.txKind.dues": "Dues",
  "accounting.txKind.minimum": "Minimum shortfall",
  "accounting.txKind.payment": "Payments",
  "accounting.txKind.credit": "Credits",
  "accounting.txKind.adjustment": "Adjustments",
  "accounting.txKind.writeoff": "Write-offs",
  "accounting.txKind.interest": "Interest and late fees",
  "accounting.view.title": "Statement: {name}",
  "accounting.view.description": "The statement exactly as it was finalised. It cannot change.",
  "accounting.view.number": "Statement {number}",
  "accounting.view.statementDate": "Dated {date}",
  "accounting.view.messages": "Messages",
  "accounting.view.summary": "Summary",
  "accounting.view.opening": "Opening balance",
  "accounting.view.charges": "Charges",
  "accounting.view.payments": "Payments",
  "accounting.view.adjustments": "Credits and adjustments",
  "accounting.view.interest": "Interest and late fees",
  "accounting.view.closing": "Closing balance",
  "accounting.view.aging": "Aged balance",
  "accounting.view.agingCurrent": "Current",
  "accounting.view.aging30": "30 days",
  "accounting.view.aging60": "60 days",
  "accounting.view.aging90": "90 days",
  "accounting.view.aging120": "120+ days",
  "accounting.view.agingTotal": "Total",
  "accounting.view.transactions": "Transactions",
  "accounting.view.noTransactions": "No transactions in this period.",
  "accounting.view.date": "Date",
  "accounting.view.what": "Description",
  "accounting.view.amount": "Amount",
  "accounting.view.balance": "Balance",
  "accounting.view.byDepartment": "By department",
  "accounting.view.department": "Department",
  "accounting.view.items": "Items",
  "accounting.view.tax": "Tax",
  "accounting.view.service": "Service",
  "accounting.view.total": "Total",
  "accounting.view.byMember": "By member",
  "accounting.view.minimum": "Minimum",
  "accounting.view.minimumLine": "{plan}: spent {spent} of {required}; {remaining} remaining.",

  "apiError.run_not_found": "That billing run no longer exists.",
  "apiError.run_not_previewed": "That run is no longer a preview, so it cannot be posted or discarded. Reload to see its state.",
  "apiError.run_not_committed": "Only a posted run can be reversed. Reload to see the run's state.",
  "apiError.period_busy": "Postings or a billing run are in progress. Wait a moment and finalise again; nothing was changed.",
  "apiError.preview_stale": "Accounts changed since this preview was made.",
  "apiError.period_not_ended": "That period has not ended yet. It can be closed once its last day has passed.",
  "apiError.period_out_of_order": "Periods are closed in order. See the status at the top of this page for the next period to close.",
  "apiError.period_already_closed": "That period is already finalised. See the status at the top of this page for the next period to close.",
  "apiError.period_closed": "That period is finalised, so nothing can be posted with a date inside it.",
  "apiError.invalid_period": "A statement period is a calendar month. Give its last day.",
  "apiError.statement_run_not_found": "That statement run no longer exists.",
  "apiError.statement_not_found": "No statement matches.",
  "apiError.run_not_finalised": "Statements exist only once the close is finalised.",
  "apiError.too_many_statements": "There are too many statements for one file. Download them by delivery method instead.",
  "apiError.reason_required": "Give a reason of at least 3 characters.",
  "apiError.has_refunds": "Part of one of the run's charges was refunded, so the run cannot be reversed as a whole.",
  "apiError.already_reversed": "One of the run's entries was already reversed separately, so the run cannot be reversed as a whole.",
} as const satisfies Record<string, string>;

export type AccountingMessages = typeof accountingEn;
